
import { Component, Prop, Vue, Watch } from 'vue-facing-decorator'
import RuleItem from "./com/rule-item.vue";
import { Action } from 'vuex-facing-decorator';
import { LockDec } from '@/decorators';

@Component({
  components: {
    RuleItem,
  }
})
export default class extends Vue {
  @Action("address/getAddress")
  getAddress;

  submitLoading = false;
  loading = false;

  formData = {
    name: "",
    postageType: 0,
    pricingType: 0,
    fixedPrice: 0,
    firstNumber: "",
    firstPrice: "",
    renewNumber: "",
    renewPrice: "",
    freePrice: "",
    area: [],
    banArea: [],
    targetArea: []
  }

  async created() {
    this.getAddress();
    this.loading = true;
    await this.getData();
    this.loading = false;
  }

  get mesureId() {
    return this.$route.query.id
  }

  async getData() {
    let id = this.mesureId;
    if (!id) return;
    let { error, data } = await this.$post("/manager/postage/postage-view", {
      id,
    });
    if (error) return;
    this.formData = data;
  }

  @LockDec("submitLoading")
  async submit() {
    await this.$postNotify(this.mesureId ? "/manager/postage/postage-edit" : "/manager/postage/postage-create", {
      ...this.formData,
      id: this.$route.query.id
    });
    this.$router.back();
  }
}
